import { render } from "./FleetTripDetail.vue?vue&type=template&id=baa521bc&scoped=true"
import script from "./FleetTripDetail.vue?vue&type=script&lang=js"
export * from "./FleetTripDetail.vue?vue&type=script&lang=js"

import "./FleetTripDetail.vue?vue&type=style&index=0&id=baa521bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa521bc"]])

export default __exports__